export enum Priorita {
	NIZKA = 'NIZKA',
	STREDNI = 'STREDNI',
	VYSOKA = 'VYSOKA'
}
